export const STORAGE_UPLOAD_BEGIN = 'STORAGE_UPLOAD_BEGIN';
export const STORAGE_UPLOAD_SUCCESS = 'STORAGE_UPLOAD_SUCCESS';
export const STORAGE_UPLOAD_FAILURE = 'STORAGE_UPLOAD_FAILURE';
export const STORAGE_UPLOAD_DISMISS_ERROR = 'STORAGE_UPLOAD_DISMISS_ERROR';



// WEBPACK FOOTER //
// ./src/features/storage/redux/constants.js